import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SplashComponent } from './components/splash/splash.component';
import { CopyrightComponent } from './components/copyright/copyright.component';
import { ButtonComponent } from './components/button/button.component';
import { AlertMessageComponent } from './components/alert-message/alert-message.component';
import { MatButtonModule, 
         MatMenuModule, 
         MatDialogModule, 
         MatFormFieldModule, 
         MatOptionModule, 
         MatSelectModule, 
         MatInputModule, 
         MatIconModule, 
         MatDatepicker,
         MatDatepickerModule,
         MatNativeDateModule,
         MatChipsModule,
         MatCheckboxModule,
         MatAutocomplete,
         MatAutocompleteModule} from '@angular/material';
import { TableComponent } from './components/table/table.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FilterComponent } from './components/filter/filter.component';
import { DownloadComponent } from './components/download/download.component';
import { AdminClassDirective } from './directives/admin-class.directive';
import { LoaderComponent } from './components/loader/loader.component';
import { ChiplistComponent } from './components/chiplist/chiplist.component';
import { AddressService } from './services/address/address.service';
import { TravelItineraryViewComponent } from './components/travel-itinerary-view/travel-itinerary-view.component';
import { ItineraryService } from './services/itinerary/itinerary.service';
import { ItineraryDetailsComponent } from './components/itinerary-details/itinerary-details.component';
import { TravelReasonComponent } from './components/travel-reason/travel-reason.component';
import { AlertModalComponent } from './components/alert-modal/alert-modal.component';
import { ReportUnliquidatedDetailComponent } from './components/report-unliquidated-detail/report-unliquidated-detail.component';
import { HeaderInfoComponent } from './components/header-info/header-info.component';
import { NotifyboxComponent } from './components/notifybox/notifybox.component';
import { LookUpLocationComponent } from './components/look-up-location/look-up-location.component';
import { ConfirmationMessageComponent } from './components/confirmation-message/confirmation-message.component';

@NgModule({
  declarations: [
    SplashComponent, 
    CopyrightComponent, 
    ButtonComponent, 
    AlertMessageComponent,
    TableComponent, 
    SearchBarComponent, 
    PaginationComponent, 
    FilterComponent,
    DownloadComponent,
    AdminClassDirective,
    LoaderComponent,
    ChiplistComponent,
    TravelItineraryViewComponent,
    ItineraryDetailsComponent,
    TravelReasonComponent,
    AlertModalComponent,
    ReportUnliquidatedDetailComponent,
    HeaderInfoComponent,
    NotifyboxComponent,
    LookUpLocationComponent,
    ConfirmationMessageComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatMenuModule,
    MatDialogModule,
    MatFormFieldModule,
    MatOptionModule,
    MatSelectModule,
    MatInputModule,
    MatIconModule,
    NgxPaginationModule,
    MatCheckboxModule,
    FormsModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatChipsModule
  ],
  exports: [
    SplashComponent,
    CopyrightComponent,
    ButtonComponent,
    SearchBarComponent,
    PaginationComponent,
    MatButtonModule,
    MatDialogModule,
    AlertMessageComponent,
    MatMenuModule,
    NgxPaginationModule,
    FilterComponent,
    DownloadComponent,
    AdminClassDirective,
    LoaderComponent,
    AlertModalComponent,
    ChiplistComponent,
    TravelReasonComponent,
    HeaderInfoComponent
  ],
  providers:[
    AddressService,
    ItineraryService
  ],
  entryComponents:[
    TravelItineraryViewComponent,
    ItineraryDetailsComponent,
    ReportUnliquidatedDetailComponent,
    NotifyboxComponent,
    LookUpLocationComponent,
    ConfirmationMessageComponent
  ]
})
export class SharedModule { }
